import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState: {
  data: any;
} = {
  data: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<any>) => {
      // localStorage.setItem("authData", JSON.stringify(action.payload));
      state.data = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuthData } = authSlice.actions;

export const selectAuthData = (state: RootState) => state.authData.data;

export default authSlice.reducer;
